import React, { useState } from "react";
import { Link as GatsbyLink } from "gatsby";
import { Link } from "react-scroll";
import { StaticImage } from "gatsby-plugin-image";
import { Navbar, Nav } from "react-bootstrap";

const Header = () => {
  const [navstateExpanded, setNavExpanded] = useState({ navExpanded: false });

  const menuExpended = (expanded) => {
    setNavExpanded({ navExpanded: expanded });
  };

  const menuExpendedclose = () => {
    setNavExpanded({ navExpanded: false });
  };
  return (
    <header className="header-nav">
      <div className="top_header">
        <div className="container-fluid">
          <div className="row justify-content-center kmc-topheader">
            <div className="col-sm-12 col-md-12 col-lg-8">
              <ul className="header-emergencyUL">
                <li>
                  <GatsbyLink to="/" style={{ cursor: "pointer" }}>
                    {" "}
                    <StaticImage
                      className="kanan-topImg"
                      src="../../assets/images/kmc-images/MaskGroup34.png"
                      alt=""
                    />{" "}
                  </GatsbyLink>
                </li>
                <li>
                  <div className="emergency_helpline pt-2">
                    Emergency
                    <br />
                    Helpline
                  </div>
                </li>
                <li>
                  <div className="emergency_helplines pt-3">
                    <StaticImage
                      className="kanan-topImg kanan-topImg-phicon"
                      src="../../assets/images/kmc-images/banner-m-icon.png"
                      alt=""
                    />
                    <p className="top-helplineText">
                      <a
                        href="tel:+91 7981284023"
                        rel="noreferrer"
                        style={{ color: "#FFFFFF", textDecoration: "none" }}
                      >
                        +91 7981284023
                      </a>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-4">
              <ul className="header-socialIcons">
                <li>
                  <StaticImage
                    src="../../assets/images/kmc-images/fb-blue.png"
                    alt="Facebook"
                  />
                </li>
                <li>
                  <StaticImage
                    src="../../assets/images/kmc-images/tw-blue.png"
                    alt="Twitter"
                  />
                </li>
                <li>
                  <StaticImage
                    src="../../assets/images/kmc-images/yt-blue.png"
                    alt="Youtube"
                  />
                </li>
                <li>
                  <StaticImage
                    src="../../assets/images/kmc-images/in-blue.png"
                    alt=""
                  />
                </li>
                <li>
                  <StaticImage
                    src="../../assets/images/kmc-images/ins-blue.png"
                    alt=""
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Navbar
        collapseOnSelect
        className="navbar navbar-expand-md px-md-4 menu-bg-dark-new bg-white navbar-kmc"
        expand="md"
        variant="dark"
        id="menu_nav_bar"
        onToggle={menuExpended}
        expanded={navstateExpanded.navExpanded}
      >
        <div className="container-fluid">
          <Link
            to="gatsby-focus-wrapper"
            className="navbar-brand img-fluid"
            smooth
            duration={500}
            style={{ cursor: "pointer" }}
          >
            <div className="newkmc-rounded-logo">
              <StaticImage
                src="../../assets/images/kmc-images/KMC_103 x103 px_Logo.png"
                alt="KMC Logo"
                className="kmc-logo-responsive-img"
              />
            </div>
            <div className="kanha-kmc">
              <p className="kanha">KANHA</p>
              <p className="medical-center">MEDICAL CENTRE</p>
            </div>
          </Link>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="m-auto-lg">
              <div id="menu-header-menu" className="nav navbar-nav">
                <div
                  className="menu-item nav-item navbar-nav"
                  // onSelect={menuExpendedclose}
                >
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    to="gatsby-focus-wrapper"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Home
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active menu-BI"
                    to="Building_Infrastructure"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Building &amp; <br />
                    Infrastructure
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active menu-BI"
                    to="Doctors_Services"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Doctors &amp; <br />
                    Services
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active"
                    to="Health_Camps"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Health Camps
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active"
                    to="offers"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Offers
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active"
                    to="testimonials"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Testimonials
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active"
                    to="job_kmc"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Jobs &amp; <br />
                    Careers
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active"
                    to="contributionskmc"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Contributions
                  </Link>
                </div>
                <div className="menu-item nav-item navbar-nav">
                  <Link
                    className="nav-link active"
                    to="contactUsKmc"
                    smooth
                    duration={500}
                    style={{ cursor: "pointer" }}
                    onClick={menuExpendedclose}
                  >
                    Contact us
                  </Link>
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>
  );
};

export default Header;
